import { Module, MutationTree, ActionTree } from 'vuex'
import { RootState } from '../types'
import repository from '../../repository'
const getDefaultState = (): SmtpServerState => {
  return {
    smtpServer: {},
    isSmtpServerLoading: false,
    isSmtpServerError: false,
    smtpServerErrorMessage: '',
    isSavedSmtpServerLoading: false,
    isSavedSmtpServerError: false,
  }
}

const state = getDefaultState()

const mutations: MutationTree<SmtpServerState> = {
  reset(state: SmtpServerState) {
    Object.assign(state, getDefaultState())
  },
  getSmtpServerObject(state: SmtpServerState, smtpServer: Partial<SmtpServer>) {
    state.smtpServer = smtpServer
  },
  setIsSmtpServerLoading(state: SmtpServerState, isSmtpServerLoading: boolean) {
    state.isSmtpServerLoading = isSmtpServerLoading
  },
  setIsSmtpServerError(state: SmtpServerState, isSmtpServerError: boolean) {
    state.isSmtpServerError = isSmtpServerError
  },
  setSmtpServerErrorMessage(
    state: SmtpServerState,
    smtpServerErrorMessage: string
  ) {
    state.smtpServerErrorMessage = smtpServerErrorMessage
  },
  setIsSavedSmtpServerLoading(
    state: SmtpServerState,
    isSavedSmtpServerLoading: boolean
  ) {
    state.isSavedSmtpServerLoading = isSavedSmtpServerLoading
  },
  setIsSavedSmtpServerError(
    state: SmtpServerState,
    isSavedSmtpServerError: boolean
  ) {
    state.isSavedSmtpServerError = isSavedSmtpServerError
  },
}

const actions: ActionTree<SmtpServerState, RootState> = {
  async getSmtpServer({ commit }, payload) {
    commit('setIsSmtpServerLoading', true)
    await repository.SmtpServer.GetSmtpServer(payload)
      .then((res) => {
        commit('getSmtpServerObject', res.data)
      })
      .catch(() => {})
      .finally(() => {
        commit('setIsSmtpServerLoading', false)
      })
  },
  async testConnection({ commit }, payload) {
    commit('setIsSmtpServerLoading', true)
    commit('setIsSmtpServerError', false)
    await repository.SmtpServer.TestConnection(payload)
      .then((res) => {
        if (!res.data) {
          commit('setIsSmtpServerError', true)
        }
      })
      .catch(() => {
        commit('setIsSmtpServerError', true)
      })
      .finally(() => {
        commit('setIsSmtpServerLoading', false)
      })
  },
  async updateSmtpServer({ commit }, payload) {
    commit('setIsSavedSmtpServerLoading', true)
    commit('setIsSavedSmtpServerError', false)
    commit('setSmtpServerErrorMessage', '')
    await repository.SmtpServer.UpdateSmtpServer(payload)
      .then((res) => {
        commit('getSmtpServerObject', res.data)
      })
      .catch((err) => {
        commit('setIsSavedSmtpServerError', true)
        commit(
          'setSmtpServerErrorMessage',
          err.response.data.messageLocalizable
        )
      })
      .finally(() => {
        commit('setIsSavedSmtpServerLoading', false)
      })
  },
}

const SmtpServer: Module<SmtpServerState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default SmtpServer

interface SmtpServer {
  objectTypeId: number
  objectId: number
  host: string
  port: number
  userName: string
  password: string
  fromEmail: string
  isFromSameAsTo: boolean
  isSslEnabled: boolean
  isTlsEnabled: boolean
}

interface SmtpServerState {
  smtpServer: Partial<SmtpServer>
  isSmtpServerLoading: boolean
  isSmtpServerError: boolean
  smtpServerErrorMessage: string
  isSavedSmtpServerLoading: boolean
  isSavedSmtpServerError: boolean
}
